import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/services/api';

/**
 * Fetches a single restaurant by id. Shares the React Query cache with other
 * callers using the same `['restaurant', id]` key, so the request is deduped.
 */
export function useRestaurant(restaurantId: number) {
  return useQuery({
    queryKey: ['restaurant', restaurantId],
    queryFn: () => apiClient.getRestaurant(restaurantId),
    enabled: !!restaurantId,
  });
}
